var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortMoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84225 12.2797C3.54903 12.2797 4.122 11.7067 4.122 11C4.122 10.2932 3.54903 9.72021 2.84225 9.72021C2.13546 9.72021 1.5625 10.2932 1.5625 11C1.5625 11.7067 2.13546 12.2797 2.84225 12.2797Z",
    fill: "#9CA3AF",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84225 3.5595C3.54903 3.5595 4.122 2.98653 4.122 2.27975C4.122 1.57296 3.54903 1 2.84225 1C2.13546 1 1.5625 1.57296 1.5625 2.27975C1.5625 2.98653 2.13546 3.5595 2.84225 3.5595Z",
    fill: "#9CA3AF",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84225 20.9999C3.54903 20.9999 4.122 20.427 4.122 19.7202C4.122 19.0134 3.54903 18.4404 2.84225 18.4404C2.13546 18.4404 1.5625 19.0134 1.5625 19.7202C1.5625 20.427 2.13546 20.9999 2.84225 20.9999Z",
    fill: "#9CA3AF",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1589 12.2797C11.8657 12.2797 12.4386 11.7067 12.4386 11C12.4386 10.2932 11.8657 9.72021 11.1589 9.72021C10.4521 9.72021 9.87915 10.2932 9.87915 11C9.87915 11.7067 10.4521 12.2797 11.1589 12.2797Z",
    fill: "#9CA3AF",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1589 3.5595C11.8657 3.5595 12.4386 2.98653 12.4386 2.27975C12.4386 1.57296 11.8657 1 11.1589 1C10.4521 1 9.87915 1.57296 9.87915 2.27975C9.87915 2.98653 10.4521 3.5595 11.1589 3.5595Z",
    fill: "#9CA3AF",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1589 20.9999C11.8657 20.9999 12.4386 20.427 12.4386 19.7202C12.4386 19.0134 11.8657 18.4404 11.1589 18.4404C10.4521 18.4404 9.87915 19.0134 9.87915 19.7202C9.87915 20.427 10.4521 20.9999 11.1589 20.9999Z",
    fill: "#9CA3AF",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortMoveIcon);
export default __webpack_public_path__ + "static/media/sort-move-icon.5998d6ccd21bb345669b2ebcbde00a2c.svg";
export { ForwardRef as ReactComponent };